import type { Translations } from './error-messages.types'

/** Hungarian texts of backend messages (ADR-045). Missing keys show the English text. */
export const hu: Translations = {
  'appointments.appointment_completed_after_has_started':
    'Egy időpont csak a kezdete után zárható le.',
  'appointments.appointment_does_need_payment':
    'Ehhez az időponthoz nem kell fizetni.',
  'appointments.appointment_no_longer_changed':
    'Ez az időpont már nem módosítható.',
  'appointments.appointment_that':
    'Ez a művelet nem lehetséges egy „{value2}” állapotú időpontnál.',
  'appointments.booking_request_invalid': 'A foglalási kérés érvénytelen.',
  'appointments.captured_payments_refunded':
    'Csak a beszedett fizetések téríthetők vissza.',
  'appointments.changes_possible_until_hours_before':
    'Módosítani az időpont előtt {cutoff} óráig lehet.',
  'appointments.exception_invalid': 'A kivétel érvénytelen.',
  'appointments.invalid_amount': 'Érvénytelen összeg.',
  'appointments.invalid_date_range': 'Érvénytelen időszak.',
  'appointments.invalid_start_time': 'Érvénytelen kezdési idő.',
  'appointments.invalid_translations': 'Érvénytelen fordítások.',
  'appointments.invalid_webhook_signature': 'Érvénytelen webhook-aláírás.',
  'appointments.key_already_used': 'A kulcs már foglalt.',
  'appointments.location_invalid': 'A helyszín érvénytelen.',
  'appointments.no_show_recorded_after_start':
    'Meg nem jelenés csak a kezdési idő után rögzíthető.',
  'appointments.online_cancel_unavailable':
    'Ennél az időpontnál nem lehet online lemondani.',
  'appointments.online_reschedule_unavailable':
    'Ennél az időpontnál nem lehet online áthelyezni.',
  'appointments.paid_service_needs_price':
    'Fizetős szolgáltatáshoz ár szükséges.',
  'appointments.payment_deadline_has_passed': 'A fizetési határidő lejárt.',
  'appointments.payment_method_available': 'Ez a fizetési mód nem érhető el.',
  'appointments.pending_appointments_confirmed_status':
    'Csak függőben lévő időpontok igazolhatók vissza (állapot: {aStatus}).',
  'appointments.please_choose_staff_member': 'Kérjük, válasszon munkatársat.',
  'appointments.policy_page_does_exist': 'A szabályzat oldala nem létezik.',
  'appointments.refund_exceeds_refundable_amount':
    'A visszatérítés meghaladja a visszatéríthető összeget.',
  'appointments.refund_failed': 'A visszatérítés sikertelen: {message}',
  'appointments.refunds_supported':
    'A(z) {adapterLabel} nem támogatja a visszatérítést.',
  'appointments.schedule_invalid': 'Az időbeosztás érvénytelen.',
  'appointments.selected_time_no_longer_available':
    'A választott időpont már nem szabad.',
  'appointments.service_invalid': 'A szolgáltatás érvénytelen.',
  'appointments.staff_member_does_work_at':
    'A munkatárs nem dolgozik ezen a helyszínen.',
  'appointments.staff_member_invalid': 'A munkatárs megadása érvénytelen.',
  'appointments.supports_full_refunds':
    'A(z) {adapterLabel} csak teljes visszatérítést támogat.',
  'appointments.test_provider_disabled_production':
    'A teszt fizetési szolgáltató éles környezetben le van tiltva.',
  'appointments.too_many_requests_please_wait':
    'Túl sok kérés ({name}). Kérjük, várjon egy kicsit.',
  'appointments.unexpected_plugin': 'Váratlan bővítmény.',
  'appointments.unknown': 'Ismeretlen: {kind}.',
  'appointments.unknown_location': 'Ismeretlen helyszín.',
  'appointments.unknown_staff_member': 'Ismeretlen munkatárs.',
  'auth.access_token_expired': 'A hozzáférési token lejárt.',
  'auth.account_active': 'A fiók nem aktív.',
  'auth.api_provided_plugin_which_enabled':
    'Ezt az API-t a(z) „{pluginKey}” bővítmény adja, amely nincs engedélyezve.',
  'auth.feature_turned_off': 'A(z) „{feature}” funkció ki van kapcsolva.',
  'auth.invalid_access_token': 'Érvénytelen hozzáférési token.',
  'auth.invalid_token_type': 'Érvénytelen tokentípus.',
  'auth.plugin_active': 'A bővítmény nem aktív.',
  'auth.plugin_credentials_accepted_service':
    'Ez a szolgáltatás nem fogad el bővítmény-hitelesítő adatokat.',
  'auth.plugin_enabled':
    'A(z) „{callerPluginKey}” bővítmény nincs engedélyezve.',
  'auth.plugin_has_been_granted':
    'A(z) „{callerPluginKey}” bővítmény nem kapta meg ezt a jogosultságot: „{capability}”.',
  'auth.unknown_token_signing_key': 'Ismeretlen token-aláíró kulcs.',
  'backup.coordinator_only':
    'Ezt a végpontot csak a mentési koordinátor használhatja.',
  'backup.import_failed': 'Az adatokat nem sikerült betölteni: {reason}',
  'backup.import_running': 'Már fut egy importálás.',
  'backup.link_expired': 'A letöltési link érvénytelen vagy lejárt.',
  'backup.not_importable':
    'Ez a mentés itt nem importálható. Töltse fel újra, hogy lássa, miért.',
  'common.dependency_unavailable':
    'Egy szükséges szolgáltatás ({dependency}) nem érhető el.',
  'common.forbidden': 'Nincs jogosultsága ehhez a művelethez.',
  'common.not_found': 'Nem található ({resource}).',
  'common.not_found_id': 'Nem található ({resource} „{id}”).',
  'common.request_invalid': 'A kérés érvénytelen.',
  'common.unauthenticated': 'Bejelentkezés szükséges.',
  'common.unexpected': 'Váratlan hiba történt.',
  'contact.invalid_message': 'Please check the form.',
  'contact.invalid_settings': 'Invalid settings.',
  'contact.recaptcha_failed':
    'A spamszűrő ellenőrzés nem sikerült. Kérjük, próbálja újra.',
  'contact.recaptcha_keys_missing':
    'A bekapcsoláshoz adja meg mindkét reCAPTCHA kulcsot.',
  'contact.recaptcha_unavailable':
    'A spamszűrő ellenőrzés most nem érhető el. Kérjük, próbálja újra később.',
  'contact.too_many_messages':
    'Too many messages. Please try again in a few minutes.',
  'content.active_content_type_needs_at':
    'Egy aktív tartalomtípusnak legalább egy mező kell.',
  'site.invalid_settings': 'Ellenőrizze a weboldal beállításait.',
  'content.add_at_least_one_field':
    'Aktiválás előtt adjon hozzá legalább egy mezőt.',
  'content.at_most_5_filters_allowed': 'Legfeljebb 5 szűrő engedélyezett.',
  'content.changing_field_compatible_existing_entries':
    'Egy {type} típusú mező a meglévő bejegyzések miatt nem alakítható {type2} típusúvá.',
  'content.content_type_already_exists':
    'A(z) „{inputKey}” tartalomtípus már létezik.',
  'content.entries_archived_content_types_published':
    'Archivált tartalomtípus bejegyzései nem tehetők közzé.',
  'content.entries_created_active_content_types':
    'Bejegyzés csak aktív tartalomtípushoz hozható létre.',
  'content.entry_data_invalid': 'A bejegyzés adatai érvénytelenek.',
  'content.entry_has_no_draft_preview':
    'A bejegyzésnek nincs előnézhető piszkozata.',
  'content.entry_has_no_draft_version':
    'A bejegyzésnek nincs piszkozatverziója.',
  'content.entry_languages_invalid': 'A bejegyzés nyelvei érvénytelenek.',
  'content.entry_published': 'A bejegyzés nincs közzétéve.',
  'content.entry_ready_publish': 'A bejegyzés még nem tehető közzé.',
  'content.entry_referenced':
    '{count} másik bejegyzés hivatkozik erre a bejegyzésre. Törölje mégis a hivatkozások eltávolításához.',
  'content.entry_referenced_one':
    'Egy másik bejegyzés hivatkozik erre a bejegyzésre. Törölje mégis a hivatkozás eltávolításához.',
  'content.entry_status':
    'Ez a művelet nem lehetséges egy {status} állapotú bejegyzésnél.',
  'content.entry_was_changed_someone_else':
    'Ezt a bejegyzést valaki más módosította. Töltse újra a legfrissebb verzióhoz.',
  'content.field_keys_renamed_while_entries':
    'A mezőkulcsok nem nevezhetők át, amíg vannak bejegyzések; adjon hozzá inkább új mezőt.',
  'content.fieldids_must_list_every_field':
    'A fieldIds listának a tartalomtípus minden mezőjét pontosan egyszer kell tartalmaznia.',
  'content.filter_must_map_field_keys':
    'A filter mezőkulcsokhoz szöveges értékeket kell rendeljen.',
  'content.filter_must_number':
    'A filter[{fieldKey}] értékének számnak kell lennie.',
  'content.filtering_supported':
    'A(z) „{fieldKey}” szerinti szűrés nem támogatott.',
  'content.invalid_content_type_key': 'Érvénytelen tartalomtípus-kulcs.',
  'content.invalid_content_type_settings':
    'Érvénytelen tartalomtípus-beállítások.',
  'content.invalid_field_definition': 'Érvénytelen mezőmeghatározás.',
  'content.invalid_schedule_time': 'Érvénytelen időpont.',
  'content.invalid_slug': 'Érvénytelen slug.',
  'content.localized_setting_change_while_entries':
    'A „fordítható” beállítás nem módosítható, amíg vannak bejegyzések.',
  'content.multiple_setting_change_while_entries':
    'A „több érték” beállítás nem módosítható, amíg vannak bejegyzések.',
  'content.page_available':
    'A(z) „{path}” oldal nem érhető el ezen a nyelven: „{locale}”.',
  'content.preview_link_invalid_has_expired':
    'Az előnézeti hivatkozás érvénytelen vagy lejárt.',
  'content.publishing_restored_version_requires_content':
    'Visszaállított verzió közzétételéhez content.entry.publish jogosultság kell.',
  'content.reserved_key': 'A(z) „{key}” foglalt kulcs.',
  'content.scheduled_time_must_future':
    'Az ütemezett időpontnak a jövőben kell lennie.',
  'content.slug_already_used_another_entry':
    'A(z) „{slug}” slugot már használja egy másik bejegyzés ({typeName}).',
  'content.type_has_entries':
    'Ennek a tartalomtípusnak {count} bejegyzése van. Törölje „force” beállítással, hogy azok is törlődjenek, vagy archiválja a típust.',
  'content.type_has_entry':
    'Ennek a tartalomtípusnak egy bejegyzése van. Törölje „force” beállítással, hogy az is törlődjön, vagy archiválja a típust.',
  'content.unsupported_locale': 'Nem támogatott nyelv: „{locale}”.',
  'content.url_already_used_another_published':
    'A(z) {nextPath} URL-t már egy másik közzétett bejegyzés használja.',
  'content.url_prefix_already_reserved':
    'A(z) „{prefix}” URL-előtagot már lefoglalta: {owner}.',
  'content.url_prefix_already_used_content':
    'A(z) „{prefix}” URL-előtagot már használja a(z) „{otherKey}” tartalomtípus.',
  'content.url_prefix_already_used_content_2':
    'A(z) „{prefix}” URL-előtagot már használja a(z) „{key}” tartalomtípus.',
  'content.url_prefix_reserved': 'A(z) „{prefix}” URL-előtag foglalt.',
  'content.url_prefix_reserved_2':
    'A(z) „{prefix}” URL-előtagot lefoglalta: {value}.',
  'content.you_delete_entries_you_created':
    'Csak a saját bejegyzéseit törölheti.',
  'crm.account_already_linked': 'Ez a fiók már össze van kapcsolva.',
  'crm.account_linked': 'Ez a fiók nincs összekapcsolva.',
  'crm.adjustments_need_reason': 'A korrekcióhoz indoklás kell.',
  'crm.another_price_already_valid_period':
    'Erre az időszakra már érvényes egy másik ár. Előbb módosítsa vagy törölje.',
  'crm.available_sale': '{fName} ({sku}) nem értékesíthető.',
  'crm.calendar_range_invalid': 'Legfeljebb {max} napos időszakot válasszon.',
  'crm.category_already_exists': 'A(z) „{inputKey}” kategória már létezik.',
  'crm.category_own_ancestor': 'Egy kategória nem lehet a saját őse.',
  'crm.choose_active_person': 'Válasszon aktív személyt.',
  'crm.choose_customer_create_new_one':
    'Válasszon ügyfelet, vagy hozzon létre újat.',
  'crm.choose_two_different_customers': 'Válasszon két különböző ügyfelet.',
  'crm.choose_two_different_warehouses': 'Válasszon két különböző raktárt.',
  'crm.comment_invalid': 'The comment is invalid.',
  'crm.count_has_no_lines': 'A leltárnak nincsenek tételei.',
  'crm.count_no_longer_editable': 'Ez a leltár már nem szerkeszthető.',
  'crm.count_was_already_posted_cancelled':
    'Ezt a leltárt már lekönyvelték vagy törölték.',
  'crm.customer_anonymized_no_tickets': 'Ezt az ügyfelet anonimizálták.',
  'crm.customer_has_been_anonymized': 'Ezt az ügyfelet anonimizálták.',
  'crm.customer_was_merged_into_another':
    'Ezt az ügyfelet egy másik ügyfélbe olvasztották.',
  'crm.delete_detach_variants_first':
    'Előbb törölje vagy válassza le a változatokat.',
  'crm.document_invalid': 'The document is invalid.',
  'crm.document_multipart':
    'Upload the document as multipart/form-data with a "file" part.',
  'crm.enough_available': 'Nincs elég {context}: {value} érhető el.',
  'crm.enough_stock': 'Nincs elég készlet.',
  'crm.event_invalid': 'Az esemény érvénytelen.',
  'crm.idempotency_key_too_long': 'Az idempotencia-kulcs túl hosszú.',
  'crm.import_columns_missing':
    'The file needs a first_name, last_name or company_name column.',
  'crm.import_file_invalid': 'The import file cannot be read.',
  'crm.import_file_missing': 'A "file" part is required.',
  'crm.import_malformed': 'Malformed upload: {message}',
  'crm.import_multipart':
    'Upload the file as multipart/form-data with a "file" part.',
  'crm.import_too_large': 'The import file may be at most {max} bytes.',
  'crm.invalid_amount': 'Érvénytelen összeg.',
  'crm.invalid_category_key': 'Érvénytelen kategóriakulcs.',
  'crm.invalid_contact': 'Érvénytelen kapcsolat.',
  'crm.invalid_contacts': 'Érvénytelen kapcsolatok.',
  'crm.invalid_country': 'Érvénytelen ország.',
  'crm.invalid_e_mail': 'Érvénytelen e-mail.',
  'crm.invalid_expiry': 'Érvénytelen lejárat.',
  'crm.invalid_quantity': 'Érvénytelen mennyiség.',
  'crm.invalid_reorder_level': 'Érvénytelen újrarendelési szint.',
  'crm.invalid_reservation_lines': 'Érvénytelen foglalási tételek.',
  'crm.invalid_sku': 'Érvénytelen cikkszám.',
  'crm.invalid_validity_interval': 'Érvénytelen érvényességi időszak.',
  'crm.invalid_warehouse_code': 'Érvénytelen raktárkód.',
  'crm.name_required': 'A név kötelező.',
  'crm.no_active_warehouse': 'Create an active warehouse first.',
  'crm.note_empty': 'A megjegyzés nem lehet üres.',
  'crm.nothing_post': 'Nincs mit lekönyvelni.',
  'crm.offering_invalid': 'Ez a kombináció nem lehetséges.',
  'crm.only_own_comments': 'You can only delete your own comments.',
  'crm.price_list_already_exists': 'A(z) „{inputKey}” árlista már létezik.',
  'crm.product_has_stock_history_deleted':
    'Ennek a terméknek van készlettörténete, ezért nem törölhető. Archiválja inkább.',
  'crm.product_own_variant': 'Egy termék nem lehet a saját változata.',
  'crm.reminder_invalid': 'The reminder is invalid.',
  'crm.reminder_not_scheduled': 'The reminder was already sent or cancelled.',
  'crm.reservation_not_changeable':
    'A foglalás állapota {status}, ezért már nem módosítható.',
  'crm.service_code_taken': 'Már létezik szolgáltatás ezzel a kóddal.',
  'crm.service_integration_client_crm':
    'A(z) „{serviceName}” szolgáltatás nem integrációs partnere a CRM-nek.',
  'crm.service_invalid': 'A szolgáltatás érvénytelen.',
  'crm.sku_already_use': 'A(z) „{sku}” cikkszám már használatban van.',
  'crm.stock_balance_was_locked': 'A készletegyenleg nem volt zárolva.',
  'crm.stock_quantity_invalid': 'The stock quantity is invalid.',
  'crm.stock_tracked_product': 'Ennél a terméknél nincs készletnyilvántartás.',
  'crm.that_customer_already_linked_another':
    'Ez az ügyfél már egy másik fiókhoz kapcsolódik.',
  'crm.ticket_closed': 'Ez a jegy le van zárva. Kérjük, nyisson újat.',
  'crm.ticket_invalid': 'A jegy érvénytelen.',
  'crm.ticket_message_invalid': 'Az üzenet érvénytelen.',
  'crm.ticket_not_shared':
    'Válasz előtt ossza meg a jegyet az ügyféllel, vagy adjon hozzá belső jegyzetet.',
  'crm.ticket_too_many_open':
    '{max} nyitott jegye van. Kérjük, várja meg a választ, mielőtt újat nyit.',
  'crm.ticket_verify_email':
    'Kérjük, erősítse meg e-mail-címét, mielőtt jegyet nyit.',
  'crm.unknown_product': 'Ismeretlen termék.',
  'crm.unknown_warehouse': 'Ismeretlen raktár.',
  'crm.unsupported_currency': 'Nem támogatott pénznem.',
  'crm.use_reservation_transfer_commands_movement':
    'Ehhez a mozgáshoz a foglalási vagy átvezetési parancsokat használja.',
  'crm.variants_have_variants': 'Egy változatnak nem lehetnek változatai.',
  'crm.warehouse_already_exists': 'A(z) „{code}” raktár már létezik.',
  'crm.warehouse_has_stock_history_deactivate':
    'Ennek a raktárnak van készlettörténete. Inaktiválja inkább.',
  'crm.warehouse_inactive': 'A(z) {wCode} raktár inaktív.',
  'crm.you_delete_your_own_notes': 'Csak a saját megjegyzéseit törölheti.',
  'crm.zip_selection_invalid': 'Select 1 to {max} documents.',
  'crm.zip_too_large': 'The selected documents are too large for one download.',
  'http.400': 'A kérés érvénytelen.',
  'http.401': 'Bejelentkezés szükséges.',
  'http.403': 'Nincs jogosultsága ehhez a művelethez.',
  'http.404': 'Nem található.',
  'http.405': 'Ez a módszer nem engedélyezett.',
  'http.409': 'A kérés ütközik a jelenlegi állapottal.',
  'http.413': 'A kérés túl nagy.',
  'http.415': 'Ez a médiatípus nem támogatott.',
  'http.429': 'Túl sok kérés. Kérjük, próbálja újra később.',
  'identity.administrator_permissions_changed':
    'Az adminisztrátor szerepkör jogosultságai nem módosíthatók.',
  'identity.at_least_one_active_administrator':
    'Legalább egy aktív adminisztrátornak maradnia kell.',
  'identity.csrf_token_missing_invalid':
    'A CSRF-token hiányzik vagy érvénytelen.',
  'identity.current_password_incorrect': 'A jelenlegi jelszó helytelen.',
  'identity.displayname_must_1_120_characters':
    'A megjelenített név 1–120 karakter lehet.',
  'identity.invalid_client_credentials':
    'Érvénytelen kliens-hitelesítő adatok.',
  'identity.invalid_credentials': 'Hibás e-mail-cím vagy jelszó.',
  'identity.invalid_email_address': 'Érvénytelen e-mail-cím.',
  'identity.invalid_plugin_key': 'Érvénytelen bővítménykulcs.',
  'identity.invalid_plugin_permissions': 'Érvénytelen bővítményjogosultságok.',
  'identity.invalid_role_key': 'Érvénytelen szerepkörkulcs.',
  'identity.link_invalid_expired': 'Ez a hivatkozás érvénytelen vagy lejárt.',
  'identity.no_active_session': 'Nincs aktív munkamenet.',
  'identity.notification_invalid': 'The notification is invalid.',
  'identity.one_more_roles_do_exist': 'Egy vagy több szerepkör nem létezik.',
  'identity.password_does_meet_password_policy':
    'A jelszó nem felel meg a jelszószabályzatnak.',
  'identity.please_confirm_your_e_mail':
    'Kérjük, előbb erősítse meg az e-mail-címét. Küldtünk egy hivatkozást.',
  'identity.role_already_exists': 'A(z) „{inputKey}” szerepkör már létezik.',
  'identity.service_may_request_plugin_credentials':
    'Ez a szolgáltatás nem kérhet bővítmény-hitelesítő adatokat.',
  'identity.session_expired_please_sign_again':
    'A munkamenet lejárt. Kérjük, jelentkezzen be újra.',
  'identity.status_set_manually': 'Az állapot kézzel nem állítható erre: {to}.',
  'identity.system_roles_deleted': 'A rendszerszerepkörök nem törölhetők.',
  'identity.unknown_permissions': 'Ismeretlen jogosultságok.',
  'identity.unknown_token_signing_key': 'Ismeretlen token-aláíró kulcs.',
  'identity.user_email_already_exists':
    'Ezzel az e-mail-címmel már létezik felhasználó.',
  'identity.you_delete_your_own_account': 'A saját fiókját nem törölheti.',
  'identity.you_disable_your_own_account': 'A saját fiókját nem tilthatja le.',
  'issue.add_at_least_one_line': 'adjon hozzá legalább egy tételt',
  'issue.add_at_least_one_product': 'adjon hozzá legalább egy terméket',
  'issue.already_used': 'már használatban van',
  'issue.ambiguous_match': 'several customers have this e-mail address',
  'issue.assign_staff_member_location_first':
    'előbb rendelje a munkatársat a helyszínhez',
  'issue.at_least_one_interval': 'legalább egy idősáv',
  'issue.at_most_200_characters': 'legfeljebb 200 karakter',
  'issue.at_most_refunded': 'legfeljebb {remaining} téríthető vissza',
  'issue.available': 'csak {total} érhető el',
  'issue.available_2': 'csak {available} érhető el',
  'issue.available_3':
    'a(z) „{shippingMethod}” nem érhető el ide: {destination}',
  'issue.available_4': 'a(z) „{provider}” nem érhető el',
  'issue.available_5': 'csak {available} érhető el ennyiből: {value}',
  'issue.belongs_gx_cms_core': 'a(z) „{prefix}” a GX-CMS maghoz tartozik',
  'issue.belongs_plugin': 'a(z) „{dKey}” a(z) „{owner}” bővítményhez tartozik',
  'issue.choose_at_least_one_feature': 'choose at least one feature',
  'issue.choose_at_least_one_language': 'válasszon legalább egy nyelvet',
  'issue.choose_one_offered_payment_methods':
    'válasszon a felkínált fizetési módok közül',
  'issue.cms_page_published': 'a(z) {path} CMS-oldal nincs közzétéve',
  'issue.configured_e_mails_logged':
    'nincs beállítva: az e-mailek csak naplózódnak',
  'issue.contains_unknown_ids': 'ismeretlen azonosítókat tartalmaz',
  'issue.contains_unknown_role_ids':
    'ismeretlen szerepkör-azonosítókat tartalmaz',
  'issue.content_language': 'nem tartalomnyelv',
  'issue.content_language_use':
    'a(z) „{l}” nem tartalomnyelv (lehetséges: {supported})',
  'issue.core_permission': 'a(z) „{dKey}” alapjogosultság',
  'issue.count_at_least_one_product': 'számoljon meg legalább egy terméket',
  'issue.crm_has_no_price_list':
    'A CRM-ben nincs „{priceList}” árlista. Hozza létre: CRM → Termékek → Árlisták, vagy módosítsa a webshop beállításait.',
  'issue.crm_plugin_disabled_unreachable_storefront':
    'A CRM bővítmény le van tiltva vagy nem érhető el. A webshop ár és készlet nélkül mutatja a termékeket, a pénztár pedig szünetel, amíg a CRM vissza nem tér.',
  'issue.crm_price_lists_could_read': 'A CRM árlistáit nem sikerült beolvasni.',
  'issue.does_exist': 'nem létezik',
  'issue.does_track_stock': 'a(z) {sku} cikknél nincs készletnyilvántartás',
  'issue.duplicate_field_key': 'ismétlődő mezőkulcs: „{fKey}”',
  'issue.duplicate_in_file': 'also in row {line}',
  'issue.e_mail_address': 'nem e-mail-cím',
  'issue.eligible_customer': 'nem megfelelő ügyfél',
  'issue.email_not_verified': 'az e-mail-cím még nincs megerősítve',
  'issue.end_after_start': 'a kezdés utáni időpontnak kell lennie',
  'issue.entries_type_allowed_here':
    '„{contentTypeKey}” típusú bejegyzés itt nem engedélyezett',
  'issue.entry_reference_itself': 'egy bejegyzés nem hivatkozhat önmagára',
  'issue.enum_fields_need_at_least':
    'a választómezőknek legalább egy lehetőség kell',
  'issue.error': '{fName} ({sku}): {message}',
  'issue.event_too_long': 'egy esemény legfeljebb {max} napig tarthat',
  'issue.exactly_one_customerid_createcustomer':
    'pontosan egy: customerId vagy createCustomer',
  'issue.exceed_price': 'nem haladhatja meg az árat',
  'issue.field_content_type': 'nem mezője ennek a tartalomtípusnak',
  'issue.fields_hold_multiple_values':
    '{type} típusú mezőnek nem lehet több értéke',
  'issue.file_does_exist_inside_package':
    'a(z) „{rel}” fájl hiányzik a csomagból (le van fordítva a bővítmény?)',
  'issue.file_empty': 'The file is empty.',
  'issue.file_too_large': 'The file is too large.',
  'issue.file_unreadable': 'The file is not a valid Excel workbook.',
  'issue.filterable': 'nem szűrhető',
  'issue.from_must_yyyy_mm_dd': 'a from és a to formátuma ÉÉÉÉ-HH-NN legyen',
  'issue.has_no_matching_events_subscribe':
    'a(z) „{cap}” jogosultsághoz nincs megfelelő events.subscribe megadás',
  'issue.import_name_column': 'no name column',
  'issue.import_sku_name_columns': 'sku and name are required',
  'issue.incorrect': 'helytelen',
  'issue.intervals_overlap': 'az idősávok átfedik egymást',
  'issue.http_url': 'http(s) URL-nek kell lennie',
  'issue.website_language': 'a weboldal egyik nyelvének kell lennie',
  'issue.invalid': 'érvénytelen',
  'issue.invalid_attendees': 'legfeljebb {max} munkatársat adjon meg',
  'issue.inventory_needs_products':
    'a készletnyilvántartáshoz termékek szükségesek',
  'issue.iso_date': 'must be a date',
  'issue.job_ids_must_unique': 'a feladat-azonosítóknak egyedinek kell lenniük',
  'issue.length_between': '1 to {min} characters',
  'issue.location_staff_required': 'helyszín vagy munkatárs megadása kötelező',
  'issue.max_characters': 'must be at most {max} characters',
  'issue.max_items': 'at most {max} tags',
  'issue.max_recipients': 'must have at most {max} recipients',
  'issue.media_asset_does_exist': 'a(z) {assetId} médiafájl nem létezik',
  'issue.media_asset_ready':
    'a(z) {assetId} médiafájl nincs kész ({assetStatus})',
  'issue.media_type_allowed': 'a(z) {mimeType} médiatípus nem engedélyezett',
  'issue.migration_ids_must_unique':
    'a migráció-azonosítóknak egyedinek kell lenniük',
  'issue.minitems_maxitems_require_multiple_true':
    'a minItems/maxItems csak multiple=true mellett használható',
  'issue.must_1_7': '1–7 lehet',
  'issue.must_above_zero': 'nullánál nagyobb kell legyen',
  'issue.must_accepted': 'el kell fogadni',
  'issue.must_after_from_at_most':
    'a kezdő dátummal egyező vagy későbbi, legfeljebb 31 nap',
  'issue.must_after_validfrom': 'a validFrom utáni kell legyen',
  'issue.must_at_least_characters': 'legalább {minLength} karakter legyen',
  'issue.must_at_most_256_characters': 'legfeljebb 256 karakter lehet',
  'issue.must_between': 'must be between {min} and {max}',
  'issue.must_boolean': 'logikai érték kell legyen',
  'issue.must_cms_path_like_terms': 'CMS-útvonal kell legyen, például /terms',
  'issue.must_contain_at_least_three':
    'legalább hármat tartalmazzon ezek közül: kisbetű, nagybetű, számjegy, írásjel',
  'issue.must_contain_duplicates': 'nem tartalmazhat ismétlődést',
  'issue.must_differ_from_source': 'el kell térjen a forrástól',
  'issue.must_differ_from_target': 'el kell térjen a céltól',
  'issue.must_endpoint_signing_secret_whsec':
    'a végpont aláíró titka kell legyen (whsec_…)',
  'issue.must_fixed_percent': 'FIXED vagy PERCENT lehet',
  'issue.must_future': 'a jövőben kell legyen',
  'issue.must_future_within_minutes':
    'a jövőben és {RESERVATIONMAXMINUTES} percen belül kell legyen',
  'issue.must_have_form_pluginkey_widgetid':
    '<pluginKey>/<widgetId> formátumú kell legyen',
  'issue.must_host_name': 'must be a host name',
  'issue.must_http_s_url_template': 'http(s) URL-sablon kell legyen',
  'issue.must_https_url': 'https:// URL kell legyen',
  'issue.must_iana_time_zone_such':
    'IANA időzóna kell legyen, például Europe/Budapest',
  'issue.must_integer': '{min} és {max} közötti egész szám legyen',
  'issue.must_iso_3166_1_alpha': 'ISO 3166-1 alpha-2 kód kell legyen',
  'issue.must_iso_8601_instant': 'ISO 8601 időpont kell legyen',
  'issue.must_iso_date_time': 'ISO dátum és idő kell legyen',
  'issue.must_list_non_empty_strings': 'nem üres szövegek listája kell legyen',
  'issue.must_max': '<= max kell legyen',
  'issue.must_maxitems': '<= maxItems kell legyen',
  'issue.must_maxlength': '<= maxLength kell legyen',
  'issue.must_newer_than_plugin_version':
    'nem lehet újabb a bővítmény verziójánál',
  'issue.must_non_negative_integer': 'nem negatív egész szám legyen',
  'issue.must_non_negative_integer_minor':
    'nem negatív egész szám legyen, fillérben',
  'issue.must_non_zero_integer': 'nullától eltérő egész szám legyen',
  'issue.must_none_tls': 'must be none or tls',
  'issue.must_number': 'szám kell legyen',
  'issue.must_object': 'objektum kell legyen',
  'issue.must_one': 'ezek egyike lehet: {FIELDTYPES}',
  'issue.must_positive_integer': 'pozitív egész szám legyen',
  'issue.must_positive_integer_minor_units':
    'pozitív egész szám legyen (fillérben)',
  'issue.must_reference_another_product': 'másik termékre kell hivatkozzon',
  'issue.must_reference_base_product': 'alaptermékre kell hivatkozzon',
  'issue.must_reference_single_value_text':
    'egyértékű szövegmezőre kell hivatkozzon',
  'issue.must_single_non_localized_enum':
    'egyetlen, nem fordítható választó- vagy kapcsolatmező lehet',
  'issue.must_start': 'ezzel kell kezdődjön: „{ns}”',
  'issue.must_start_letter_contain_letters':
    'betűvel kezdődjön, és csak betűt, számjegyet és _ jelet tartalmazzon',
  'issue.must_stripe_secret_restricted_key':
    'Stripe titkos vagy korlátozott kulcs kell legyen (sk_…/rk_…)',
  'issue.must_text_at_most_120': 'legfeljebb 120 karakteres szöveg lehet',
  'issue.must_url_path': '{ url } vagy { path } kell legyen',
  'issue.must_valid_email_address': 'érvényes e-mail-cím kell legyen',
  'issue.must_valid_regular_expression':
    'érvényes reguláris kifejezés kell legyen',
  'issue.must_valid_semver_range': 'érvényes semver-tartomány kell legyen',
  'issue.must_yyyy_mm_dd': 'ÉÉÉÉ-HH-NN formátumú legyen',
  'issue.needs_hh_mm_start_before':
    'ÓÓ:pp formátum kell, a kezdet a vége előtt',
  'issue.no_active_shipping_method': 'Nincs aktív szállítási mód.',
  'issue.no_longer_available': '{value} már nem érhető el',
  'issue.no_payment_method_enabled_configured':
    'Nincs engedélyezett és beállított fizetési mód.',
  'issue.no_published_cms_page_at': 'nincs közzétett CMS-oldal itt: {path}',
  'issue.non_negative_amount': 'nem lehet negatív összeg',
  'issue.not_in_past': 'must not be in the past',
  'issue.notification_link': 'must be an admin path starting with /',
  'issue.notification_permissions': 'must be permission keys',
  'issue.notification_recipients': 'name at least one user or permission',
  'issue.notification_source': 'use lower-case letters, digits and . _ : -',
  'issue.notification_text': 'use a text or { "<language>": text }',
  'issue.notification_too_many_users': 'at most {max} users',
  'issue.notification_type': 'use lower-case letters, digits and . _ -',
  'issue.notification_user_ids': 'must be user ids',
  'issue.page_widget_field_widget_ids':
    'az oldal-, modul- és mezőmodul-azonosítóknak egyedinek kell lenniük',
  'issue.paid_service_needs_currency': 'fizetős szolgáltatáshoz pénznem kell',
  'issue.paid_service_needs_price_above':
    'fizetős szolgáltatáshoz nullánál nagyobb ár kell',
  'issue.permission_keys_must_unique':
    'a jogosultságkulcsoknak egyedinek kell lenniük',
  'issue.plugin_depend_itself': 'egy bővítmény nem függhet önmagától',
  'issue.positive_minutes': 'pozitív percszámnak kell lennie',
  'issue.posted_directly': 'a(z) „{type}” nem könyvelhető közvetlenül',
  'issue.product_does_exist': 'a(z) {id} termék nem létezik',
  'issue.provide_display_name_person_name':
    'adjon meg megjelenített nevet, személynevet vagy cégnevet',
  'issue.range_too_long': 'a megengedett tartományon kívül esik',
  'issue.referenced_entry_archived':
    'a hivatkozott {targetEntryId} bejegyzés archivált',
  'issue.referenced_entry_does_exist':
    'a hivatkozott {targetEntryId} bejegyzés nem létezik',
  'issue.references_undeclared_feature':
    "references undeclared feature '{feature}'",
  'issue.references_undeclared_page':
    'meg nem adott oldalra hivatkozik: „{page}”',
  'issue.reminder_range': '0 perc és 14 nap között kell lennie',
  'issue.requested_plugin': 'a bővítmény nem kéri ezt: „{c}”',
  'issue.required': 'kötelező',
  'issue.required_8_120_characters': 'kötelező (8–120 karakter)',
  'issue.required_content_type': 'ennél a tartalomtípusnál kötelező',
  'issue.required_event_subscriptions_jobs':
    'eseményfeliratkozásokhoz és feladatokhoz kötelező',
  'issue.required_price_iso_4217': 'ár megadásakor kötelező (ISO 4217)',
  'issue.required_service': 'ennél a szolgáltatásnál kötelező',
  'issue.required_verify_webhooks': 'a webhookok ellenőrzéséhez kötelező',
  'issue.required_when_admin_ui_extensions':
    'kötelező, ha adminisztrációs bővítések vannak megadva',
  'issue.required_when_permissions_features_declared':
    'kötelező, ha jogosultságok vagy funkciók vannak megadva',
  'issue.requires_capability': '{why} ehhez a jogosultsághoz kötött: „{cap}”',
  'issue.reserved': 'foglalt',
  'issue.reserved_2': 'a(z) „{fieldKey}” foglalt',
  'issue.reserved_3': 'a(z) „{prefix}” foglalt',
  'issue.reserved_storefront':
    'a(z) „{categorySlug}” a webshop számára foglalt',
  'issue.row_failed': 'could not be imported',
  'issue.select_documents': 'select 1 to {max} documents',
  'issue.sender_name': 'must be at most 120 characters without < > or quotes',
  'issue.shop_currency_but_crm_price':
    'A webshop pénzneme {currency}, de a(z) „{priceList}” CRM-árlista pénzneme {currency2}. Hozzon létre {currency} pénznemű árlistát, és válassza ki a webshop beállításaiban, vagy állítsa a webshop pénznemét erre: {currency3}.',
  'issue.simplepay_supports_huf_eur_usd':
    'A SimplePay HUF, EUR és USD pénznemet támogat',
  'issue.supported': 'a(z) „{currency}” nem támogatott',
  'issue.supported_fields': '{type} típusú mezőknél nem támogatott',
  'issue.supported_locale': 'nem támogatott nyelv',
  'issue.supported_routing_setting': 'nem támogatott útválasztási beállítás',
  'issue.supported_setting': 'nem támogatott beállítás',
  'issue.tag_max_characters': 'tags must be at most {max} characters',
  'issue.tax_rate_range': '0 és 100 % között kell lennie',
  'issue.test_provider_used_production':
    'a teszt fizetési szolgáltató éles környezetben nem használható',
  'issue.too_large': 'túl nagy',
  'issue.too_long': 'túl hosszú',
  'issue.too_long_max_1000': 'túl hosszú (max. 1000)',
  'issue.too_many_columns': 'The file has too many columns (at most {max}).',
  'issue.too_many_rows': 'The file has too many rows (at most {max}).',
  'issue.translations_fields': 'formátum: { "<nyelv>": { {fields} } }',
  'issue.unavailable': 'nem érhető el',
  'issue.unknown_capability': 'ismeretlen jogosultság: „{cap}”',
  'issue.unknown_field': 'ismeretlen mező',
  'issue.unknown_permission': 'ismeretlen jogosultság: „{p}”',
  'issue.unsupported_currency': 'nem támogatott',
  'issue.use_0': '0–{MAXQTY} közötti érték',
  'issue.use_1_32_letters_digits': '1–32 betű, számjegy, kötőjel vagy aláhúzás',
  'issue.use_1_64_letters_digits':
    '1–64 betű, számjegy, pont, kötőjel vagy aláhúzás',
  'issue.use_2_63_lowercase_letters':
    '2–63 kisbetű, számjegy vagy _, betűvel kezdve',
  'issue.use_either_https_url_cms':
    'vagy HTTPS URL-t, vagy CMS-útvonalat adjon meg, ne mindkettőt',
  'issue.use_iso_3166_1_alpha': 'ISO 3166-1 alpha-2 kódot adjon meg',
  'issue.use_lower_case_letters_digits': 'kisbetűk, számjegyek és kötőjelek',
  'issue.use_lowercase_letters_digits': 'kisbetűk, számjegyek, - és _',
  'issue.use_lowercase_letters_digits_dashes':
    'kisbetűk, számjegyek és kötőjelek (max. 60)',
  'issue.use_lowercase_letters_digits_single':
    'kisbetűk, számjegyek és egyes kötőjelek',
  'issue.use_one': 'lehetséges: {supported}',
  'issue.use_one_2': 'lehetséges: {CONTENTLOCALES}',
  'issue.use_one_3': 'lehetséges: {value}',
  'issue.valid_e_mail_address': 'nem érvényes e-mail-cím',
  'issue.valid_json_schema': 'nem érvényes JSON-séma: {message}',
  'issue.valid_phone_number': 'nem érvényes telefonszám',
  'issue.webshop_needs_inventory':
    'a webshop készletet foglal; előbb kapcsolja ki a webshopot',
  'issue.webshop_needs_products':
    'a webshop termékeket árul; előbb kapcsolja ki a webshopot',
  'issue.whole_number_min_0': 'must be a whole number ≥ 0',
  'issue.would_create_cycle': 'körkörös hivatkozást hozna létre',
  'issue.xls_unsupported':
    'Old Excel files (.xls) are not supported. Save the file as .xlsx or CSV.',
  'mail.invalid_plugin_key': "'{pluginKey}' is not a plugin key.",
  'mail.invalid_request': 'Invalid e-mail.',
  'mail.invalid_smtp_settings': 'Invalid e-mail settings.',
  'mail.password_unreadable':
    'The stored SMTP password cannot be read; enter it again.',
  'mail.secrets_key_missing':
    'Set MAIL_SECRETS_KEY on the identity service to store SMTP passwords.',
  'mail.send_plugins_services_only':
    'Only plugins and services send e-mail through this API.',
  'mail.service_not_mail_client':
    "Service '{service}' may not send e-mail (MAIL_CLIENTS).",
  'media.deleted_assets_changed': 'Törölt médiafájl nem módosítható.',
  'media.file_empty': 'A fájl üres.',
  'media.file_part_required': 'Egy „file” rész kötelező.',
  'media.file_type_allowed_allowed_types':
    'Ez a fájltípus nem engedélyezett. Engedélyezett típusok: {allowed}.',
  'media.file_used':
    'Ezt a fájlt {count} bejegyzés használja. Ha mégis törli, ott nem töltődik be többé, és a bejegyzéseknek a következő közzététel előtt új fájl kell.',
  'media.file_used_once':
    'Ezt a fájlt egy bejegyzés használja. Ha mégis törli, ott nem töltődik be többé, és a bejegyzésnek a következő közzététel előtt új fájl kell.',
  'media.files_may_at_most_bytes':
    'A fájlok legfeljebb {maxBytes} bájtosak lehetnek.',
  'media.files_may_at_most_bytes_2':
    'A fájlok legfeljebb {MEDIAMAXBYTES} bájtosak lehetnek.',
  'media.malformed_upload': 'Hibás feltöltés: {message}',
  'media.owner_scope_invalid': 'A valid owner scope is required.',
  'media.text_file_invalid': 'The text file is not valid UTF-8 text.',
  'media.use_multipart_form_data_file':
    'Használjon multipart/form-data kérést „file” résszel.',
  'media.you_delete_media_you_uploaded':
    'Csak a saját feltöltésű médiát törölheti.',
  'mobileapp.app_key_required':
    'This API is for approved apps (app key required).',
  'mobileapp.bad_signature': 'The request signature is not valid.',
  'mobileapp.feature_not_granted':
    "This website has not granted the app '{feature}'.",
  'mobileapp.instance_key_mismatch':
    'This app installation is registered with another key.',
  'mobileapp.invalid_decision': 'Invalid decision.',
  'mobileapp.invalid_invite': 'Invalid invite.',
  'mobileapp.invalid_registration': 'Invalid registration request.',
  'mobileapp.invalid_settings': 'Invalid settings.',
  'mobileapp.invite_required':
    'This website accepts app connections only with an invite code.',
  'mobileapp.not_approved': 'The registration is not approved.',
  'mobileapp.not_pending': 'Only a pending request can be refused.',
  'mobileapp.revoke_first': 'Revoke the connection before deleting it.',
  'mobileapp.too_many_requests':
    'Too many registration requests. Please try again later.',
  'plugin.capabilities_requested_manifest_granted':
    'Csak a manifestben kért jogosultságok adhatók meg.',
  'plugin.complete_plugin_configuration_before_enabling':
    'Engedélyezés előtt töltse ki a bővítmény beállításait.',
  'plugin.disable_dependent_plugins_first':
    'Előbb tiltsa le a függő bővítményeket: {value}.',
  'plugin.disable_plugin_before_uninstalling':
    'Eltávolítás előtt tiltsa le a bővítményt.',
  'plugin.enable_dependencies_first':
    'Előbb engedélyezze a függőségeket: {value}.',
  'plugin.gx_cms_instance_installs_signed':
    'Ez a GX-CMS példány csak aláírt bővítménycsomagokat telepít.',
  'plugin.incompatible': 'A bővítmény nem kompatibilis: {problems}',
  'plugin.install_plugin_before_changing_features':
    'A funkciók módosítása előtt telepítse a bővítményt.',
  'plugin.install_plugin_before_granting_capabilities':
    'Jogosultságok megadása előtt telepítse a bővítményt.',
  'plugin.invalid_collection_record_key':
    'Érvénytelen gyűjtemény- vagy rekordkulcs.',
  'plugin.invalid_plugin_configuration': 'Érvénytelen bővítménykonfiguráció.',
  'plugin.invalid_plugin_manifest': 'Érvénytelen bővítmény-manifest.',
  'plugin.migration_failed': 'A(z) „{migId}” migráció sikertelen: {message}',
  'plugin.migrations_have_completed': 'Befejezetlen migrációk: {value}.',
  'plugin.needs_service_which_installation_does':
    'A(z) „{pluginKey}” igényli a(z) „{serviceName}” szolgáltatást, amelyet ez a telepítés nem csatlakoztat (SERVICE_PLUGINS).',
  'plugin.no_newer_version_available': 'Nincs újabb verzió.',
  'plugin.package_signature_invalid': 'A csomag aláírása érvénytelen.',
  'plugin.package_signature_invalid_refusing_install':
    'A csomag aláírása érvénytelen; a telepítés elutasítva.',
  'plugin.plugin_already_installed':
    'A(z) „{key}” bővítmény már telepítve van.',
  'plugin.plugin_does_hold_storage_plugin':
    'A bővítmény nem rendelkezik storage.plugin jogosultsággal.',
  'plugin.plugin_enabled': 'A bővítmény nincs engedélyezve.',
  'plugin.plugin_enabled_from_status':
    'A(z) „{key}” bővítmény {pluginStatus} állapotból nem engedélyezhető.',
  'plugin.plugin_installed': 'A bővítmény nincs telepítve.',
  'plugin.plugin_package_no_longer_present':
    'A bővítménycsomag már nincs a tárban.',
  'plugin.records_may_at_most_bytes':
    'A rekordok legfeljebb {PLUGINDATAMAXBYTES} bájtosak lehetnek.',
  'plugin.service_bound_plugin_service_plugins':
    'A(z) „{serviceName}” szolgáltatás nincs ehhez a bővítményhez csatlakoztatva (SERVICE_PLUGINS).',
  'plugin.service_setup_failed':
    'A szolgáltatás beállítása sikertelen: {reason}',
  'plugin.turned_yet': 'A(z) „{flag}” még nem kapcsolható be.',
  'plugin.uninstall_dependent_plugins_first':
    'Előbb távolítsa el a függő bővítményeket: {value}.',
  'plugin.uninstall_plugin_before_deleting':
    'Törlés előtt távolítsa el a bővítményt.',
  'plugin.unknown_capabilities_provided_dependency':
    'Ismeretlen jogosultságok (egyik függőség sem biztosítja): {undeclared}.',
  'plugin.use_retry_migrations_uninstall_first':
    'Futtassa újra a migrációkat, vagy előbb távolítsa el.',
  'runtime.migration_already_running':
    'A(z) {pluginKey} bővítménynél már fut egy migráció.',
  'runtime.migration_failed': 'A bővítmény migrációja sikertelen: {reason}',
  'validation.arrayMaxSize': '{property}: túl sok elem',
  'validation.arrayMinSize': '{property}: túl kevés elem',
  'validation.isArray': '{property}: lista szükséges',
  'validation.isBoolean': '{property}: igaz vagy hamis érték szükséges',
  'validation.isDateString': '{property}: ISO dátum szükséges',
  'validation.isEmail': '{property}: e-mail-cím szükséges',
  'validation.isEnum': '{property}: nem engedélyezett érték',
  'validation.isHexColor': '{property}: hexa színkód szükséges',
  'validation.isIP': '{property}: IP-cím szükséges',
  'validation.isISO8601': '{property}: ISO dátum szükséges',
  'validation.isIn': '{property}: nem engedélyezett érték',
  'validation.isInt': '{property}: egész szám szükséges',
  'validation.isLocale': '{property}: nyelvkód szükséges',
  'validation.isNotEmpty': '{property}: nem lehet üres',
  'validation.isNumber': '{property}: szám szükséges',
  'validation.isObject': '{property}: objektum szükséges',
  'validation.isPhoneNumber': '{property}: telefonszám szükséges',
  'validation.isPositive': '{property}: pozitív szám szükséges',
  'validation.isString': '{property}: szöveg szükséges',
  'validation.isUUID': '{property}: UUID szükséges',
  'validation.isUrl': '{property}: URL szükséges',
  'validation.length': '{property}: hibás hossz',
  'validation.matches': '{property}: érvénytelen formátum',
  'validation.max': '{property}: túl nagy',
  'validation.maxLength': '{property}: túl hosszú',
  'validation.min': '{property}: túl kicsi',
  'validation.minLength': '{property}: túl rövid',
  'validation.nestedValidation': '{property}: érvénytelen',
  'validation.whitelistValidation':
    'A(z) {property} tulajdonság nem engedélyezett',
  'webshop.active_crm_products_listed': 'Csak aktív CRM-termékek listázhatók.',
  'webshop.amount_too_large': 'Túl nagy összeg.',
  'webshop.available': 'Csak {available} érhető el ebből: {viewName}.',
  'webshop.available_sale_right_now': '{viewName} most nem kapható.',
  'webshop.cart_empty': 'A kosár üres.',
  'webshop.cart_token_missing': 'A kosár tokenje hiányzik.',
  'webshop.cart_was_already_checked_out': 'Ezt a kosarat már megrendelték.',
  'webshop.choose_payment_method': 'Válasszon fizetési módot.',
  'webshop.choose_shipping_method': 'Válasszon szállítási módot.',
  'webshop.configured': 'A(z) {providerLabel} nincs beállítva.',
  'webshop.import_columns_missing': 'The file needs sku and name columns.',
  'webshop.import_file_invalid': 'The import file cannot be read.',
  'webshop.import_file_missing': 'A "file" part is required.',
  'webshop.import_malformed': 'Malformed upload: {message}',
  'webshop.import_multipart':
    'Upload the file as multipart/form-data with a "file" part.',
  'webshop.import_too_large': 'The import file may be at most {max} bytes.',
  'webshop.invalid_amount': 'Érvénytelen összeg.',
  'webshop.invalid_category': 'Érvénytelen kategória.',
  'webshop.invalid_code': 'Érvénytelen kód.',
  'webshop.invalid_price': 'Érvénytelen ár.',
  'webshop.invalid_quantity': 'Érvénytelen mennyiség.',
  'webshop.invalid_slug': 'Érvénytelen slug.',
  'webshop.invalid_translations': 'Érvénytelen fordítások.',
  'webshop.invalid_webhook_signature': 'Érvénytelen webhook-aláírás.',
  'webshop.order_action_not_possible':
    'Ez nem lehetséges egy „{status}” állapotú rendelésnél.',
  'webshop.order_already_belongs_another_account':
    'Ez a rendelés már egy másik fiókhoz tartozik.',
  'webshop.order_has_no_captured_payment':
    'Ennél a rendelésnél nincs beszedett fizetés.',
  'webshop.payment_window_order_has_expired':
    'A rendelés fizetési határideje lejárt.',
  'webshop.please_accept_terms': 'Kérjük, fogadja el az ÁSZF-et.',
  'webshop.product_needs_current_price_price':
    'A terméknek aktuális {currency} ár kell a(z) „{priceList}” árlistán.',
  'webshop.refund_exceeds_refundable_amount':
    'A visszatérítés meghaladja a visszatéríthető összeget.',
  'webshop.refunds_supported':
    'A(z) {adapterLabel} nem támogatja a visszatérítést.',
  'webshop.reserved_category': 'Foglalt kategória.',
  'webshop.sales_unavailable':
    'Az árak, a készlet és a pénztár átmenetileg nem érhetők el. Kérjük, próbálja újra később.',
  'webshop.slug_already_used': 'A(z) „{inputSlug}” slug már foglalt.',
  'webshop.some_items_changed_please_review':
    'Néhány tétel megváltozott. Kérjük, ellenőrizze a kosarát.',
  'webshop.some_items_just_sold_out':
    'Néhány tétel épp elfogyott. Kérjük, ellenőrizze a kosarát.',
  'webshop.supports_full_refunds':
    'A(z) {adapterLabel} csak teljes visszatérítést támogat.',
  'webshop.test_provider_disabled_production':
    'A teszt fizetési szolgáltató éles környezetben le van tiltva.',
  'webshop.unexpected_plugin': 'Váratlan bővítmény.',
  'webshop.unknown_tax_category': 'Ismeretlen adókategória.',
  // English until translated.
  'crm.attachment_multipart':
    'A fájlt multipart/form-data formában, „file” részként töltsd fel.',
  'crm.attachment_too_large': 'A fájlok legfeljebb {max} MB méretűek lehetnek.',
  'crm.ticket_attachments_invalid': 'A mellékletek érvénytelenek.',
  'crm.ticket_attachments_unknown':
    'Egy melléklet nem található. Töltsd fel újra.',
  'issue.max_files': 'legfeljebb {max} fájl lehet',
}
